export default {
  upload_common: {
    required: 'Câu hỏi này là bắt buộc',
    max_length_500: 'Hãy trả lời trong giới hạn 500 từ.',
    please_enter_a_number: 'Nhập số',
    unexpected_error: 'Đã xảy ra lỗi không mong muốn',
    temporarily_saved: 'Đã lưu',
    unanswered_items: 'Vẫn còn các câu hỏi chưa trả lời',
    answer_questionnaire_select: 'Chọn phiếu câu hỏi',
    entry: 'Vui lòng điền vào',
    target_select: 'Chọn',
    value_unit: 'Số',
    unit: 'Đơn vị',
    attach_documents: 'Đính kèm tệp',
    textarea_placeholder: 'Vui lòng viết câu trả lời khi được yêu cầu hoặc nếu muốn thêm bất kỳ lời giải thích bổ sung nào.',
    // textarea_placeholder_with_file: '',
    temporary_storage: 'Lưu',
    submit: 'Gửi',
    last_saved_temporary: 'Lần cập nhật gần nhất',
    There_are_unanswered_questions: 'Vẫn còn các câu hỏi chưa trả lời',
    submitted_text: 'Đã gửi khảo sát này.',
    submitted_at: 'Ngày nộp',
    withdrawal_of_answer: 'Rút lại khảo sát đã nộp',
    withdrawal_accepted: 'Chấp nhận rút lại',
    help: 'Trợ giúp',
    example_of_evidence: 'Ví dụ về bằng chứng',
    save_temporary_answer: 'Lưu khảo sát',
    saved_temporary_answer: 'Câu trả lời của bạn đã được lưu lại.',
    submit_answer: 'Gửi khảo sát',
    confirm_submit_answer: 'Bạn có chắc chắn muốn gửi khảo sát không?',
    confirm_submit_shared_text: '\nPhản hồi của bạn trong khảo sát sẽ được chia sẻ với người mua.',
    complete_submit_answer: 'Đã gửi khảo sát.\nCảm ơn bạn đã hợp tác cùng chúng tôi.',
    // recommend_asuene: '',
    // not_at_all: '',
    // absolutely: '',
    // let_us_know_your_thoughts: '',
    // thank_you_for_your_cooperation: '',
    // glad_to_support: '',
    back_answer: 'Quay lại',
    close: 'Đóng',
    save_temporary_answer_and_prev: 'Lưu và trở lại',
    save_temporary_answer_and_next: 'Lưu và chuyển sang tiếp theo',
    prev: 'Trở lại',
    next: 'Tiếp theo',
    question_group_question_download: 'Tải xuống khảo sát',
    question_group_answer_download: 'Tải xuống câu trả lời',
    question_group_download_answer_csv_title: 'Câu hỏi・Câu trả lời(CSV)',
    question_group_download_answer_csv_description: 'Tải xuống câu trả lời dưới dạng csv.',
    question_group_download_answer_pdf_title: 'Câu hỏi・Câu trả lời(PDF)',
    question_group_download_answer_pdf_description: 'Tải xuống câu trả lời dưới dạng pdf.',
    question_group_download_scorecard_pdf_title: 'Thẻ điểm(PDF)',
    question_group_download_scorecard_pdf_description: 'Tải xuống điểm dưới dạng pdf.',
    question_group_download_esg_award_svg_title: 'Giải thưởng ESG(SVG)',
    question_group_download_esg_award_svg_description: 'Tải xuống giải thưởng dưới dạng svg.',
    question_group_download_esg_award_pdf_title: 'Giải thưởng ESG(PDF)',
    question_group_download_esg_award_pdf_description: 'Tải xuống giải thưởng dưới dạng pdf.',
    request_survey_withdrawal: 'Yêu cầu rút lại khảo sát',
    survey_withdrawal_description: 'Yêu cầu rút lại sẽ được gửi đến Người mua của bạn.\nVui lòng ghi rõ dưới đây lý do tại sao bạn muốn rút lại khảo sát. Chi tiết về yêu cầu của bạn sẽ được chia sẻ với Người mua của bạn.',
    reason_withdrawal_request: 'Lý do yêu cầu rút lại',
    completed_withdrawal_request: 'Yêu cầu rút lại của bạn đã được chấp nhận. Vui lòng đợi đến khi yêu cầu được duyệt.',
    send: 'Gửi',
    cancel: 'Hủy bỏ',
    balloon_title_withdrawal_request: 'Yêu cầu rút lại của bạn đã được chấp nhận.',
    no_survey: 'Không có yêu cầu khảo sát có sẵn.',
    failed_to_save_before_export: 'Không lưu tạm thời được trước khi tải xuống tệp. Vui lòng kiểm tra để chắc chắn thông tin đã nhập là chính xác',
    filter_unfilled_questions: 'Chỉ hiển thị các khảo sát chưa trả lời',
    no_unfilled_questions: 'Không có các câu hỏi chưa trả lời',
    move_page: 'Đi đến trang tiếp',
    confirm_move_page_message: 'Câu trả lời của bạn không được lưu. \nNếu bạn chuyển sang trang khác, câu trả lời của bạn sẽ bị mất.Bạn có muốn lưu câu trả lời trước khi di chuyển không?',
    confirm_without_save: 'Không lưu',
    confirm_with_save: 'Lưu',
    error_save: 'Không thể lưu tạm thời. Vui lòng kiểm tra câu trả lời của bạn.',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: 'Khảo sát đang được chỉnh sửa',
    unable_edit_someone_editing_survey: 'Không thể chỉnh sửa khảo sát tại thời điểm này vì hiện đang có người dùng đang chỉnh sửa khảo sát.',
    user_editing_survey: 'hiện đang được chỉnh sửa.',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: 'Câu trả lời trước đó',
      // overwrite_with_previous_answers: "",
      submitted_at: '(Đã gửi ngày {submitted_at})',
      // related_question: "",
      click_to_expand: 'Nhấp để mở rộng',
      click_to_omit: 'Nhấp để bỏ qua',
      // description: "",
      answer_reference_function: 'Chức năng tham khảo câu trả lời',
      overwrite: 'Ghi đè',
      overwrite_confirm: 'Hành động này sẽ điền các câu trả lời trước đó cho những câu hỏi đã được trả lời trong các khảo sát trước đó.\nBất kỳ câu hỏi nào đã được trả lời sẽ bị ghi đè.',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: 'Mục',
      activity_amount: 'Lượng',
      emission_factor: 'Hệ số phát thải',
      emission_amount: 'Phát thải',
      unit_sale: 'Cường độ phát thải',
      total: 'Tổng',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/một triệu YÊN',
    },
    label: {
      required_answer: 'Câu trả lời bắt buộc',
      optional_answer: 'Câu trả lời tùy chọn',
      conditional_required_answer: 'Phân nhánh câu trả lời bắt buộc',
      note: 'Lưu ý',
      // evidence_attachments: "",
    },
    //  required_answer: '',
    //  optional_answer: '',
    //  conditional_required_answer: '',
    //  note: '',
    //  evidence_attachments: '',
    // no_available_in_pdf: ''
    // comparison_question_meta: '',
    // error_footer: '',
    // error_panel_title: '',
    // error_panel_description: '',
    // error_panel_support_text_1: '',
    // error_panel_support_label: '',
    // error_panel_support_text_2: '',
    // error_panel_resolved: '',
    // error: '',
    // error_revision_required: '',
    // alert: '',
    // alert_detected: '',
    question_group_download_answered_csv_title: 'Câu hỏi・Câu trả lời(CSV)',
    question_group_download_answered_pdf_title: 'Câu hỏi・Câu trả lời(PDF)',
  }
}
